import { render, staticRenderFns } from "./FooterIncident.vue?vue&type=template&id=145b5dc8&"
import script from "./FooterIncident.vue?vue&type=script&lang=js&"
export * from "./FooterIncident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports